import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { VehicleItem } from './components/VehicleItem'

type Props = RenderItemProps<'unifiedVehicles'>

export function Item(props: Props) {
  return props.type === 'item' ? <VehicleItem {...props} /> : null
}
